import { call, put, takeLatest } from "redux-saga/effects";
import actionCreators from "../../actions/ambassadors/ambassadors";
import "babel-polyfill";

/**
 * アンバサダー募集検索
 */
function* getManagerRecruitments(action) {
  let param = `?pref_id=${action.payload.prefId}&service_id=${
    action.payload.serviceId
  }`;
  try {
    const result = yield call(function() {
      const method = "GET";
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      return fetch(`/api/companies/manager_recruitments_search/${param}`, {
        method,
        headers,
      })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(actionCreators.ambassadors.ambassadors.success({ list: result }));
  } catch (e) {
    yield put(actionCreators.ambassadors.ambassadors.failure({ list: [] }));
  }
}

/**
 * 都道府県リスト取得
 */
// eslint-disable-next-line no-unused-vars
function* getPrefList(_action) {
  try {
    const result = yield call(function() {
      const method = "GET";
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      return fetch("/api/locations/pref_list", { method, headers })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(
      actionCreators.ambassadors.ambassadors.success({ prefList: result.prefs })
    );
  } catch (e) {
    yield put(actionCreators.ambassadors.ambassadors.failure({ prefList: [] }));
  }
}

/**
 * サービスリスト取得
 */
// eslint-disable-next-line no-unused-vars
function* getServiceList(_action) {
  try {
    const result = yield call(function() {
      const method = "GET";
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      return fetch("/api/services", { method, headers })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(
      actionCreators.ambassadors.ambassadors.success({
        serviceList: result.services,
      })
    );
  } catch (e) {
    yield put(
      actionCreators.ambassadors.ambassadors.failure({ serviceList: [] })
    );
  }
}

export default function*() {
  // アンバサダー募集検索
  yield takeLatest(
    actionCreators.ambassadors.ambassadors.getManagerRecruitments,
    getManagerRecruitments
  );
  // 都道府県リスト取得
  yield takeLatest(
    actionCreators.ambassadors.ambassadors.getPrefList,
    getPrefList
  );
  // サービスリスト取得
  yield takeLatest(
    actionCreators.ambassadors.ambassadors.getServiceList,
    getServiceList
  );
}
